import { render, staticRenderFns } from "./AdminMac.vue?vue&type=template&id=4dfd9c90&scoped=true"
import script from "./AdminMac.vue?vue&type=script&lang=js"
export * from "./AdminMac.vue?vue&type=script&lang=js"
import style0 from "./AdminMac.vue?vue&type=style&index=0&id=4dfd9c90&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfd9c90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dfd9c90')) {
      api.createRecord('4dfd9c90', component.options)
    } else {
      api.reload('4dfd9c90', component.options)
    }
    module.hot.accept("./AdminMac.vue?vue&type=template&id=4dfd9c90&scoped=true", function () {
      api.rerender('4dfd9c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/AdminMac.vue"
export default component.exports